import React, { PureComponent } from 'react';
import { Button } from '@material-ui/core';
import FlagOutlined from '@material-ui/icons/FlagOutlined';
import Icon from '@material-ui/core/Icon';
import AddCourseMileStone from '../../coursePlan/AddCourseMileStone';

interface AddNewMilestoneProps {
  data: any;
  atBottom?: boolean;
}

interface AddNewMilestoneState {
  isHovering: boolean;
  open: boolean;
  addMilestone: boolean;
}

class AddNewMilestone extends PureComponent<AddNewMilestoneProps, AddNewMilestoneState> {
  constructor(props: AddNewMilestoneProps) {
    super(props);

    this.state = {
      open: false,
      isHovering: false,
      addMilestone: false,
    };
  }

  onClickMilestone = () => {
    this.setState({ addMilestone: !this.state.addMilestone, open: true });
  };

  closeAddMilstone = () => {
    this.setState({ addMilestone: false, open: false });
  };

  handleMouseHover = () => {
    this.setState({ isHovering: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovering: false });
  };
  render() {
    const { isHovering, open, addMilestone } = this.state;
    return (
      <div
        style={{
          minHeight: '3vh',
          marginTop: this.props.atBottom ? '-1.4vh' : '-4.2vh',
          // marginLeft: '-2vw',
          marginBottom: '1vh',
          // marginTop: '-9px'
          cursor: 'pointer',
        }}
        onMouseEnter={this.handleMouseHover}
        onMouseLeave={this.handleMouseLeave}
      >
        {isHovering ? (
          !open ? (
            <div style={{ display: 'flex', alignItems: 'center', height: '3vh' }}>
              <span
                onClick={() => {
                  this.setState({ open: true });
                }}
              >
                <Icon color='primary'>add_circle</Icon>
              </span>
              <span
                style={{
                  borderTop: '2px solid #1e88e5',
                  width: '100%',
                  marginLeft: '-3px',
                }}
              />
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span
                onClick={() => {
                  this.setState({ open: false, addMilestone: false });
                }}
              >
                <Icon
                  color='primary'
                  style={{
                    transform: 'rotate(45deg)',
                  }}
                >
                  add_circle
                </Icon>
              </span>
              <span
                style={{
                  borderTop: '2px solid #1e88e5',
                  width: '28px',
                  marginLeft: '-3px',
                }}
              />
              <Button
                style={{
                  marginTop: '-6px',
                  width: '193px',
                  background: '#fff',
                  border: '1px solid rgba(153, 153, 153, 0.3)',
                  borderRadius: '4px',
                  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
                }}
                color='primary'
                onClick={this.onClickMilestone}
              >
                <span>
                  <FlagOutlined color='primary' />
                </span>
                <span>Add Milestone</span>
              </Button>
              <span
                style={{
                  borderTop: '2px solid #1e88e5',
                  width: '100%',
                  marginLeft: '-3px',
                }}
              />
            </div>
          )
        ) : (
          <></>
        )}

        {addMilestone && (
          <AddCourseMileStone
            parentNode={this.props.data}
            closeHoverBar={this.closeAddMilstone}
            atBottom={this.props.atBottom || false}
          />
        )}
      </div>
    );
  }
}

export default AddNewMilestone;
